"use strict";

module.exports = {
    "user2": {
        "add-account": "Добавить аккаунт",
        "edit-accounts": "Редактировать список",
        "enter": "Войти",
        "exit": "Выйти",
        "help": "Помощь",
        "mail": ["новое письмо", "новых письма", "новых писем", "Нет новых писем"],
        "mail_compose": "Написать письмо",
        "passport": "Управление аккаунтом",
        "settings": "Настройки",
        "upload_files": "Мой диск"
    }
};